import { gql } from '@efficiently/client-core-graphql-models';

export const SAVE_FINISH_SPECIFICATIONS = gql(`
	mutation ProjectLocationSaveFinishSpecifications($records: [FinishToSpecificationInput!]!) {
		saveFinishSpecifications(records: $records) {
			...FinishDomainFinishToSpecificationFields
		}
	}
`);

export const DELETE_FINISH_SPECIFICATIONS = gql(`
	mutation ProjectLocationDeleteFinishSpecifications($ids: [String!]!, $finishId: String!) {
		deleteFinishSpecifications(ids: $ids, finishId: $finishId) {
			...FinishDomainFinishToSpecificationFields
		}
	}
`);
